import { render } from "./MassServiceActions.vue?vue&type=template&id=8af48e38"
import script from "./MassServiceActions.vue?vue&type=script&lang=js"
export * from "./MassServiceActions.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__